export const CALENDAR_LIST = {
	name: '日历事件列表',
	api: '${BASE}/bcp-apps/api/B/calender/event/list',
	doc: 'http://192.168.15.26:8180/rtmap-app/doc.html#9d218d257bfcb628946ce6d83f052d05',
};

export const CALENDAR_INFO = {
	name: '日历事件详情',
	api: '${BASE}/bcp-apps/api/B/calender/event/get',
	doc: 'http://192.168.15.26:8180/rtmap-app/doc.html#f2d31b11053ad273ca19cfb86528fc56',
};

export const CALENDAR_ADD = {
	name: '添加日历事件',
	api: '${BASE}/bcp-apps/api/B/calender/event/save',
	method: 'post',
	doc: 'http://192.168.15.26:8180/rtmap-app/doc.html#9708e26753fee980cb9f4dbe85fa21fb',
};

export const CALENDAR_UPDATE = {
	name: '更新日历事件',
	api: '${BASE}/bcp-apps/api/B/calender/event/edit',
	method: 'post',
	doc: 'http://192.168.15.26:8180/rtmap-app/doc.html#20882036e47a48dd2e8ec76e1e96a71a',
};

export const CALENDAR_REMOVE = {
	name: '删除日历事件',
	api: '${BASE}/bcp-apps/api/B/calender/event/delete',
	doc: 'http://192.168.15.26:8180/rtmap-app/doc.html#ee4850eb4a26c9733153962c90609e7b',
};

export const ACTIVITY_LIST = {
	name: '活动列表',
	api: '${BASE}/bcp-apps/api/B/B/activity/list',
	method: 'post',
	doc: 'http://192.168.15.26:8180/rtmap-app/doc.html#5557fa472e9e8d6a3768749dbfe219df',
};

export const ACTIVITY_COUNT_TOTAL = {
	name: '活动数量统计',
	api: '${BASE}/bcp-apps/api/B/B/activity/statistics/get',
	doc: 'http://192.168.15.26:8180/rtmap-app/doc.html#d6354c642f80cdf0ea4306ee1b88fc35',
};

export const ACTIVITY_PUASE_ALL = {
	name: '暂停所有活动',
	api: '${BASE}/bcp-apps/api/B/B/activity/all/stop',
	doc: 'http://192.168.15.26:8180/rtmap-app/doc.html#89238eea8dbddcea9a604564bb566a73',
};

export const ACTIVITY_INFO = {
	name: '获取活动详情',
	api: '${BASE}/bcp-apps/api/B/B/app/activity/detail',
	doc: 'http://192.168.15.26:8180/rtmap-app/doc.html#e4857df05bfaedc8cfead0e9643eee33',
};

export const ACTIVITY_STATUS_UPDATE = {
	name: '修改活动状态',
	api: '${BASE}/bcp-apps/api/B/B/app/activity/status/update',
	method: 'post',
	doc: 'http://192.168.15.26:8180/rtmap-app/doc.html#c7037905c3a7ead7b5ad3da1508ba5b0',
};

export const ACTIVITY_GROUP_LIST = {
	name: '查询活动组列表',
	api: '${BASE}/bcp-apps/api/B/B/activity/group/list',
	doc: 'http://192.168.15.26:8180/rtmap-app/doc.html#f39f6261672add743a78ca9399d014d7',
};
export const ACTIVITY_GROUP_ADD = {
	name: '创建活动组',
	api: '${BASE}/bcp-apps/api/B/B/activity/group/create',
	method: 'post',
	doc: 'http://192.168.15.26:8180/rtmap-app/doc.html#72ce610ceebd3527c2c7acfc88491a59',
};
export const ACTIVITY_GROUP_REMOVE = {
	name: '删除活动组',
	api: '${BASE}/bcp-apps/api/B/B/activity/group/remove',
	doc: 'http://192.168.15.26:8180/rtmap-app/doc.html#5f3fe1315a832117a063c1f3c15570d7',
};
export const ACTIVITY_GROUP_ASSIGN = {
	name: '变更活动对应的活动组',
	api: '${BASE}/bcp-apps/api/B/B/app/activity/group/change',
	method: 'post',
	doc: 'http://192.168.15.26:8180/rtmap-app/doc.html#a932e2bc44ae10d3f467b82093f73312',
};

export const ACTIVITY_INFO_MEMBER_LIST = {
	name: '获取活动下的触达会员列表',
	api: '${BASE}/bcp-crm-dev/api/B/customer/member/list/activityId',
	method: 'post',
	doc: 'http://wiki.rt.com:8090/pages/viewpage.action?pageId=20612330',
};

export const ACTIVITY_INFO_CHANNEL_LIST = {
	name: '获取活动下的渠道详情列表',
	api: '${BASE}/bcp-channel-dev/api/B/requisition/listByActivityId',
	doc: 'http://wiki.rt.com:8090/pages/viewpage.action?pageId=20612697',
};

export const ACTIVITY_INFO_CHANNEL_LIST_RECORD = {
	name: '获取活动下的渠道详情的明细记录列表',
	api: '${BASE}/bcp-channel-dev/api/B/requisition/pushRecord/list',
	doc: 'http://wiki.rt.com:8090/pages/viewpage.action?pageId=20612699',
};

export const ACTIVITY_INFO_CHANNEL_UPDATE = {
	name: '更新活动下的渠道详情状态',
	api: '${BASE}/bcp-channel-dev/api/B/requisition/status',
	method: 'post',
	doc: 'http://wiki.rt.com:8090/pages/viewpage.action?pageId=20612701',
};

export const ACTIVITY_INFO_REPORT = {
	name: '获取活动报告',
	api: '${DATA}/ds-api/api/activity/report',
	method: 'post',
	doc: 'http://192.168.15.56:8193/ds-api/doc.html#7b21cc37a79a2f5981541a73d585eec7',
};
